export type ColumnId = 'Details' | 'Open' | 'Status' | 'Action'

export type ScopeChangeRequestSortField = 'CreateTime' | 'Id'

export interface ScopeChangeRequestColumnDetails {
  id: ColumnId
  header: string
  align: 'left' | 'right' | 'center'
  select: boolean
  sortable: boolean
  field?: ScopeChangeRequestSortField
}

export const ScopeChangeRequestTableColumns: ScopeChangeRequestColumnDetails[] =
  [
    {
      id: 'Details',
      header: 'Details',
      select: false,
      align: 'left',
      sortable: false,
    },
    {
      id: 'Open',
      header: 'Open',
      select: false,
      align: 'left',
      sortable: true,
      field: 'CreateTime',
    },
    {
      id: 'Status',
      header: 'Status',
      select: false,
      align: 'center',
      sortable: false,
    },
    {
      id: 'Action',
      header: '',
      select: false,
      align: 'left',
      sortable: false,
    },
  ]
